const NODE_ENV = process.env.NODE_ENV;

export function invariant(condition, message) {
  if (condition) return;
  throw new Error(message);
}

export function log(message) {
  if (NODE_ENV === 'production') return;
  console.log(message);
}

export function flowToObservable(arg) {
  if (typeof arg !== 'object' || !arg._isGentHubFlow) 
    return arg;
  return arg.toObservable();
}

export function catchError(fn) {
  return function(...args) {
    try {
      return fn.bind(this)(...args);
    } catch (e) {
      console.log('uncaught exception:', e);
      throw e;
    }
  }
}